import { context, propagation } from '@opentelemetry/api'

// Baggage is sent to every propagated request: keep this list small and never add PII, patient data or tokens.
export const ALLOWED_BAGGAGE_KEYS: readonly string[] = ['session.id', 'ui.action', 'app.version']

/**
 * Runs `fn` with the given entries added to the active W3C baggage, so they are sent as the `baggage`
 * header by XHR/fetch calls started inside `fn`. Keys outside `ALLOWED_BAGGAGE_KEYS` are dropped.
 */
export function runWithBaggage<T>(entries: Record<string, string>, fn: () => T): T {
  let bag = propagation.getBaggage(context.active()) ?? propagation.createBaggage()
  for (const [key, value] of Object.entries(entries)) {
    if (!ALLOWED_BAGGAGE_KEYS.includes(key)) {
      console.warn(`Baggage key "${key}" is not allowed and was dropped`)
      continue
    }
    bag = bag.setEntry(key, { value })
  }
  return context.with(propagation.setBaggage(context.active(), bag), fn)
}
